import { render, staticRenderFns } from "./EmployeeAttendance.vue?vue&type=template&id=37540036&scoped=true"
import script from "./EmployeeAttendance.vue?vue&type=script&lang=js"
export * from "./EmployeeAttendance.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAttendance.vue?vue&type=style&index=0&id=37540036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37540036",
  null
  
)

export default component.exports